import React from 'react';
import Input from 'components/common/Input';
import { EventBus } from 'events/EventBus';
import { CanvasEvent } from 'events/EventTypes';
import styles from './index.module.scss';


export const WordExampleComponent = ({ object }) => {

  let wordExampleInfo = object.wordExampleInfo ? JSON.parse(object.wordExampleInfo) : { src: '', word: '' }

  const changeHandler = infoType => e => {
    wordExampleInfo[infoType] = e.target.value;
    EventBus.emit({ event: CanvasEvent.ModifyCanvasObjectPropertyEvent, payload: { object, property: "wordExampleInfo", value: JSON.stringify(wordExampleInfo) } });
};



  return (
    <>
      <Input className={styles.wordExampleInput} label="Src" value={wordExampleInfo.src} onChange={changeHandler('src')} />
      <Input className={styles.wordExampleInput} label="Word" value={wordExampleInfo.word} onChange={changeHandler('word')} />
    </>
  )
};